<template>
  <div class="pagination">
    <button @click="goToFirstPage" :disabled="isFirstPage" class="pagi-arrow">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.2 11.1998L4 7.9998L7.2 4.7998M12 11.1998L8.8 7.9998L12 4.7998"
          stroke="#909090"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
    <button @click="goToPrevPage" :disabled="isFirstPage" class="pagi-arrow">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.73336 11.2002L6.40002 7.86686L9.73336 4.53353"
          stroke="#909090"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>

    <button v-for="page in displayedPages" :key="page" @click="changePage(page)" class="pagination-num" :class="{active: page === nowPage}">
      {{ page }}
    </button>

    <button @click="goToNextPage" :disabled="isLastPage" class="pagi-arrow">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.26664 11.2002L9.59998 7.86686L6.26664 4.53353"
          stroke="#909090"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
    <button @click="goToLastPage" :disabled="isLastPage || totalPages <= 10" class="pagi-arrow">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.8 4.8002L12 8.0002L8.8 11.2002M4 4.8002L7.2 8.0002L4 11.2002"
          stroke="#909090"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    totalCount: {
      type: Number,
      required: true
    },
    nowPage: {
      type: Number,
      required: true
    },
    limit: {
      type: Number,
      default: 90
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalCount / this.limit)
    },
    isFirstPage() {
      return this.nowPage === 1
    },
    isLastPage() {
      return this.nowPage === this.totalPages
    },
    startPage() {
      return Math.floor((this.nowPage - 1) / 10) * 10 + 1
    },
    displayedPages() {
      const start = this.startPage
      const end = Math.min(start + 9, this.totalPages)
      return Array.from({length: end - start + 1}, (_, i) => start + i)
    }
  },
  methods: {
    changePage(page) {
      this.$emit('changePage', page)
    },
    goToFirstPage() {
      this.changePage(1)
    },
    goToLastPage() {
      this.changePage(this.totalPages)
    },
    goToPrevPage() {
      if (this.nowPage > 1) {
        this.changePage(this.nowPage - 1)
      }
    },
    goToNextPage() {
      if (this.nowPage < this.totalPages) {
        this.changePage(this.nowPage + 1)
      }
    }
  }
}
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.pagi-arrow {
  &:hover {
    path {
      stork: #212121;
    }
  }
}

.pagination-num {
  border: 1px solid #dbdbdb;
  background: #fff;
  color: #909090;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%; /* 17.5px */
  letter-spacing: -0.2px;
  cursor: pointer;
  &:hover {
    background: #f2f2f2;

    color: #606060;
  }
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

button.active {
  background: #0058aa;
  border: 1px solid #0058aa;
  color: #fff;
}
</style>
